module.exports = __webpack_public_path__ + "static/img/6.55eadb24.png";